import { LaunchContextFixture, type BootConfigDefaults } from "@slot/game-shell";

/**
 * What coin-hold states about its boot (`launchGame`'s defaults); the shell reads the env names and the URL flags
 * itself (`createBootConfig`). The title has no backend yet, so every build plays its offline server and
 * `?backend=staging` names no server. The offline launch fixture is MOBILE: the e2e desktop project boots with
 * `?device=desktop`.
 */
export const coinHoldBootDefaults: BootConfigDefaults = {
  stagingBackendUrl: "",
  launchContextFixture: LaunchContextFixture.Mobile,
  assetsBaseUrl: "./assets",
  denominationFactor: 100,
};
